import { createBrowserClient } from "@supabase/ssr";

type SupabaseBrowserEnv = {
  url: string;
  key: string;
};

const SUPABASE_AUTH_COOKIE_NAME = "sb-moveon-auth-token";

export function getSupabaseBrowserEnv(): SupabaseBrowserEnv | null {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const key = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;
  // Legacy fallback kept here for quick rollback during asymmetric-key migration.
  // const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !key) {
    return null;
  }

  return { url, key };
}

export function createBrowserSupabaseClient() {
  const supabaseEnv = getSupabaseBrowserEnv();

  if (!supabaseEnv) {
    throw new Error(
      `Supabase credentials missing:
      URL: ${process.env.NEXT_PUBLIC_SUPABASE_URL ? "present" : "missing"}
      KEY: ${process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ? "present" : "missing"}

      Please ensure you have:
      1. Created a .env.local file
      2. Added NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY
      3. For rollback only, you can temporarily restore NEXT_PUBLIC_SUPABASE_ANON_KEY
      4. Restarted the Next.js development server
      `,
    );
  }

  return createBrowserClient(supabaseEnv.url, supabaseEnv.key, {
    cookieOptions: {
      name: SUPABASE_AUTH_COOKIE_NAME,
    },
  });
}

// export const createSupabaseBrowserClient = createBrowserSupabaseClient; // NOTE: use only if needed
export const browserSupabaseClient = createBrowserSupabaseClient(); // prefer singleton pattern for easier imports
